<template>
  <div>
    <legend>Daily Cap</legend>

    <CRow
      form
      class="form-group"
    >
      <CCol
        tag="label"
        sm="3"
        class="col-form-label text-right font-weight-bold"
      >
        {{ toggleLabel }}
      </CCol>
      <CCol
        sm="9"
        class="mt-1"
      >
        <CSwitch
          shape="pill"
          :checked.sync="enabled"
          color="primary"
          @update:checked="onToggle"
        />
      </CCol>
    </CRow>

    <CRow
      v-if="enabled"
      form
      class="form-group"
    >
      <CCol
        tag="label"
        sm="3"
        class="col-form-label text-right font-weight-bold"
      >
        Max Payout Per Day
      </CCol>
      <CCol
        sm="5"
        lg="4"
      >
        <CInput
          :value="capValue"
          type="number"
          :min="1"
          step="1"
          name="Daily Cap"
          placeholder="Daily Cap"
          description="Whole US dollars per day"
          :is-valid="validationState"
          invalid-feedback="Daily Cap must be a whole dollar amount of at least $1"
          @input="onCapInput"
        >
          <template #prepend-content>
            $
          </template>
        </CInput>
      </CCol>
    </CRow>
  </div>
</template>

<script>
export default {
  name: 'DailyCapInput',

  props: {
    value: {
      type: Number,
      default: null
    },
    submitted: {
      type: Boolean,
      default: false
    },
    toggleLabel: {
      type: String,
      default: 'Limit Daily Payout'
    },
    defaultCap: {
      type: Number,
      default: 1000
    }
  },

  data() {
    return {
      enabled: false,
      capValue: null
    }
  },

  computed: {
    isValid() {
      return !this.enabled || (Number.isInteger(this.capValue) && this.capValue >= 1)
    },

    validationState() {
      if (!this.submitted || !this.enabled) {
        return null
      }

      return this.isValid
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        // Unlike RateLimitInput the value is a scalar, so an empty input emitting null
        // must not flip the toggle off — only ever force it ON from an incoming value.
        if (val != null) {
          this.enabled = true
          this.capValue = val
        } else if (!this.enabled) {
          this.capValue = null
        }
      }
    },

    isValid: {
      immediate: true,
      handler(val) {
        this.$emit('validity-change', val)
      }
    }
  },

  methods: {
    onToggle(newEnabled) {
      if (newEnabled) {
        this.capValue = this.defaultCap
        this.$emit('input', this.defaultCap)
      } else {
        this.capValue = null
        this.$emit('input', null)
      }
    },

    onCapInput(value) {
      this.capValue = value === '' ? null : Number(value)
      this.$emit('input', this.capValue)
    }
  }
}
</script>
